/* Paleta IGSS — clínico, azul institucional (sin verde oliva) */
const primary = '#206890';
const primarySoft = '#E8F1F6';
/* Éxito: teal alineado al azul (reemplaza verde oliva) */
const success = '#2A8F7A';
const danger = '#C04545';
const gold = '#C4A574';
const text = '#2A3A44';
const textMuted = '#5E7380';
const bgLight = '#F4F8FA';
const border = '#D5E0E6';
const boxShadow = '0 1px 2px 0 rgba(32, 104, 144, 0.08)';
const bgPrimaryLight = 'rgba(32, 104, 144, 0.18)';
const primaryGradient = primary;
const widthFull = '260px';
const widthResize = '60px';
const widthWithPadding = '240px';
const widthResizeWithPadding = '40px';
const heightHeader = '56px';
const heightFooter = '40px';

export {
  boxShadow,
  primary,
  primarySoft,
  success,
  danger,
  gold,
  text,
  textMuted,
  bgLight,
  border,
  bgPrimaryLight,
  primaryGradient,
  widthFull,
  widthResize,
  heightHeader,
  heightFooter,
  widthWithPadding,
  widthResizeWithPadding,
};
